import React, { useCallback, useMemo } from 'react';

import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { buildDefaultPrintSetting } from '../../../../containers/print-document-button-containers/core/buildDefaultPrintSetting';
import { DocumentType } from '../../../../enums/document-type';
import { PrintDocumentButtonHelperService } from '../../../../services/print-document-button-container-helper-service';
import { bulkLabelDirectPrint, bulkLabelDownload } from '../../../../store/orders/orders.actions';
import { printLabel } from '../../../../store/printing/print.actions';
import PrintDocumentMenuItem from '../../../print-document-menu-item';

export const Label = ({ fulfillments, printSetting, userHasShippingRole }) => {
  const dispatch = useDispatch();
  const isDisabled = fulfillments.every((fulfillment) => fulfillment?.isLabelVoided ?? true) || !userHasShippingRole;

  const onClick = useCallback(() => {
    const { activeFulfillmentIds, fulfillmentPlanIdsWithLabel, hasPrintedLabel } =
      PrintDocumentButtonHelperService.getPrintModalData(fulfillments);
    dispatch(printLabel(fulfillmentPlanIdsWithLabel, activeFulfillmentIds, hasPrintedLabel, false, false));
  }, [dispatch, fulfillments]);
  const onPrint = useCallback(() => {
    dispatch(bulkLabelDirectPrint());
  }, [dispatch]);
  const onDownload = useCallback(() => {
    dispatch(bulkLabelDownload());
  }, [dispatch]);
  const defaultPrintSetting = useMemo(
    () => buildDefaultPrintSetting(printSetting, onPrint, onDownload),
    [onDownload, onPrint, printSetting],
  );

  return (
    <PrintDocumentMenuItem
      defaultPrintSetting={defaultPrintSetting}
      disabled={isDisabled}
      name={DocumentType.Label.documentNameTranslation}
      onClick={onClick}
    />
  );
};

Label.propTypes = {
  fulfillments: PropTypes.arrayOf(
    PropTypes.shape({
      isLabelVoided: PropTypes.bool,
    }),
  ).isRequired,
  printSetting: PropTypes.any,
  userHasShippingRole: PropTypes.bool.isRequired,
};
